import {
  CLEAR_USER_BY_ID,
  CLEAR_USERS,
  GET_USER_BY_ID,
  GET_USER_BY_ID_SUCCESS,
  SEARCH_USERS,
  SEARCH_USERS_SUCCESS,
  SET_USERS_LOADING,
  DEACTIVATE_USER,
  DEACTIVATE_USER_SUCCESS,
  DEACTIVATE_USER_ERROR,
  ACTIVATE_USER,
  ACTIVATE_USER_SUCCESS,
  ACTIVATE_USER_ERROR,
  DELETE_USER_BY_ID,
  DELETE_USER_BY_ID_SUCCESS,
  DELETE_USER_BY_ID_ERROR,
  GET_SYSTEM_USER,
  UPDATE_SYSTEM_USER_ON_STUDENT,
  UPDATE_SYSTEM_USER_ON_CONTACT,
  CREATE_SYSTEM_USER_ON_STUDENT,
  CREATE_SYSTEM_USER_ON_CONTACT,
  GET_STUDENT_INFO,
  GET_STUDENT_INFO_SUCCESS,
  GET_STUDENT_INFO_ERROR,
  CREATE_STUDENT,
  CREATE_STUDENT_SUCCESS,
  CREATE_STUDENT_ERROR,
  UPDATE_STUDENT,
  UPDATE_STUDENT_SUCCESS,
  UPDATE_STUDENT_ERROR,
} from '../constants/ActionTypes';

export const clearUserById = () => ({
  type: CLEAR_USER_BY_ID,
});

export const clearUsers = () => ({
  type: CLEAR_USERS,
});

export const getUserById = (id, forRefresh) => ({
  type: GET_USER_BY_ID,
  payload: { id, forRefresh },
});

export const getUserByIdSuccess = (user = {}) => ({
  type: GET_USER_BY_ID_SUCCESS,
  payload: { user },
});

export const searchUsers = (query = {}, affectQuery = false) => ({
  type: SEARCH_USERS,
  payload: { affectQuery, query },
});

export const searchUsersSuccess = (users, pageCount) => ({
  type: SEARCH_USERS_SUCCESS,
  payload: { users, pageCount },
});

export const setUsersLoading = (flag = false) => ({
  type: SET_USERS_LOADING,
  payload: { flag },
});

export const deactivateUserRole = ({ ids, userId }) => ({
  type: DEACTIVATE_USER,
  payload: { ids, userId },
});

export const deactivateUserRoleSuccess = () => ({
  type: DEACTIVATE_USER_SUCCESS,
});

export const deactivateUserRoleError = () => ({
  type: DEACTIVATE_USER_ERROR,
});

export const activateUserRole = ({ ids, userId }) => ({
  type: ACTIVATE_USER,
  payload: { ids, userId },
});

export const activateUserRoleSuccess = () => ({
  type: ACTIVATE_USER_SUCCESS,
});

export const activateUserRoleError = () => ({
  type: ACTIVATE_USER_ERROR,
});

export const deleteUser = userId => ({
  type: DELETE_USER_BY_ID,
  payload: { userId },
});

export const deleteUserSuccess = () => ({
  type: DELETE_USER_BY_ID_SUCCESS,
});

export const deleteUserError = () => ({
  type: DELETE_USER_BY_ID_ERROR,
});

export const createStudent = payload => ({
  type: CREATE_STUDENT,
  payload,
});

export const createStudentSuccess = () => ({
  type: CREATE_STUDENT_SUCCESS,
});

export const createStudentError = () => ({
  type: CREATE_STUDENT_ERROR,
});

export const updateStudent = payload => ({
  type: UPDATE_STUDENT,
  payload,
});

export const updateStudentSuccess = () => ({
  type: UPDATE_STUDENT_SUCCESS,
});

export const updateStudentError = () => ({
  type: UPDATE_STUDENT_ERROR,
});

export const getStudentInfo = ({ userId }) => ({
  type: GET_STUDENT_INFO,
  payload: { userId },
});

export const getStudentInfoSuccess = ({ data }) => ({
  type: GET_STUDENT_INFO_SUCCESS,
  payload: { data },
});

export const getStudentInfoError = () => ({
  type: GET_STUDENT_INFO_ERROR,
});

export const getSystemUser = (userId, meta, loading) => ({
  type: GET_SYSTEM_USER,
  payload: { userId, meta, loading },
});

export const createSystemUserOnStudent = ({ formData, meta, pupilId }) => ({
  type: CREATE_SYSTEM_USER_ON_STUDENT,
  payload: { formData, meta, pupilId },
});

export const createSystemUserOnContact = ({ formData, meta }) => ({
  type: CREATE_SYSTEM_USER_ON_CONTACT,
  payload: { formData, meta },
});

export const updateSystemUserOnStudent = ({ formData, meta, userId, pupilId }) => ({
  type: UPDATE_SYSTEM_USER_ON_STUDENT,
  payload: { formData, meta, userId, pupilId },
});

export const updateSystemUserOnContact = ({ formData, meta, userId }) => ({
  type: UPDATE_SYSTEM_USER_ON_CONTACT,
  payload: { formData, meta, userId },
});
